import {Tooltip} from 'primereact/tooltip'
import {UniqueKeyGenerator} from '../../../../util/uniqueKeyGenerator'


/**
 * provide the text to display and the max length of the text. if it exceeds
 * the max length it is shortened and a tooltip is added with the full text.
 * @param text
 * @param maxDisplayLength
 * @constructor
 */
export const TextBodyWithTooltip = (text: string, maxDisplayLength: number = 30) => {
	let textToDisplay = ''
	const isTooLong = (text.length + 3) >= maxDisplayLength

	if (isTooLong) {
		const randomKey = UniqueKeyGenerator('shortened-text-body')
		textToDisplay = `${text.substring(0, 27)}...`

		return <div className={randomKey}>
			<span>{textToDisplay}</span>
			<Tooltip
				target={`.${randomKey}`}
				content={text}
				position={'top'}
			/>
		</div>
	}
	return 	<span>{text}</span>

}